export const LocalhostDomain = "localhost";
export const WorksDomain = "21re.works";
export const LiveDomain = "21re.de";
export const ServicesDomain = "21re.services";
export const PromoDomain = "21re.promo";
export function getCurrentServiceRoot(location) {
    if (!location.protocol) {
        return `https://${location.host}`;
    }
    return `${location.protocol}//${location.host}`;
}
export function getCurrentDomain(location) {
    const domainParts = location.host.split(".");
    if (domainParts.length < 2) {
        return location.host;
    }
    return `${domainParts[domainParts.length - 2]}.${domainParts[domainParts.length - 1]}`;
}
export function getSanitizedDomain(location) {
    return isLocalhost(location)
        ? "localhost"
        : getCurrentDomain(location).split(":")[0];
}
export function isLocalhost(location) {
    return location.host.indexOf(LocalhostDomain) >= 0;
}
export function isLocalhostOrOneOfTheGivenDomains(location, domains) {
    const currentDomain = getCurrentDomain(location);
    return (domains.some((domain) => domain === currentDomain) || isLocalhost(location));
}
export function getServiceName(location) {
    const domainParts = location.host.split(".");
    if (domainParts.length < 3) {
        return null;
    }
    return domainParts[0];
}
export function getStage(location) {
    if (isLocalhost(location))
        return null;
    const domainParts = location.host.split(".");
    if (domainParts.length < 3) {
        return null;
    }
    return domainParts[2];
}
//# sourceMappingURL=domain.js.map